function handleMenuLateralFixoNova(topoMenu, menuLateralEsquerdo, topoSubmenu) {
    if (topoMenu.length > 0) {
        if (topoMenu.hasClass('animation')) {
            menuLateralEsquerdo.css('height', 'calc(100vh - ' + topoMenu.outerHeight() + 'px)');
        } else {
            if (topoSubmenu.length > 0) {
                if (topoSubmenu.offset().top <= $(window).scrollTop()) {
                    menuLateralEsquerdo.css('top', $(".js-menu-fixed-topo").outerHeight() + 'px');
                    menuLateralEsquerdo.css('height', '88vh');
                }
            } else {
                menuLateralEsquerdo.css('height', '85vh');
            }
        }
    } else {
        if (topoSubmenu.length > 0) {
            let topoSubmenuOffsetTop = topoSubmenu.offset().top;
            let offset = topoSubmenu.outerHeight()
            menuLateralEsquerdo.css('top', offset + 'px');
            if (topoSubmenuOffsetTop <= $(window).scrollTop()) {
                menuLateralEsquerdo.css(
                    'height',
                    'calc(100vh - ' + offset + 'px)'
                );
            } else {
                menuLateralEsquerdo.css(
                    'height',
                    'calc(100vh - ' + (offset + topoSubmenuOffsetTop) + 'px)'
                );
            }
        } else {
            menuLateralEsquerdo.css('height', '83vh');
        }
    }
}

function init() {
    let topoMenu = $('.topo-menu-wrapper');
    let menuLateralEsquerdo = $('.navegacao-lateral-flex');
    let topoSubmenu = $(".js-menu-fixed-topo")

    handleMenuLateralFixoNova(topoMenu, menuLateralEsquerdo, topoSubmenu);
    $(window).scroll(function () {
        handleMenuLateralFixoNova(topoMenu, menuLateralEsquerdo, topoSubmenu);
    });
    $(window).resize(function () {
        handleMenuLateralFixoNova(topoMenu, menuLateralEsquerdo, topoSubmenu);
    });
}

module.exports = {
    init
};


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/menu-fixo-lateral.js